// 複刻文化 Fuko — 區塊標題
// 支援三種視覺變體：default（標準）、editorial（編輯式）、dark（深色背景）
// 可加入區塊序號與英文識別標籤

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  sectionNumber?: string;
  englishLabel?: string;
  variant?: 'default' | 'editorial' | 'dark';
}

export default function SectionHeader({
  title,
  subtitle,
  align = 'left',
  sectionNumber,
  englishLabel,
  variant = 'default',
}: SectionHeaderProps) {
  const isDark = variant === 'dark';
  const isEditorial = variant === 'editorial';

  return (
    <div className={`mb-10 md:mb-12 ${align === 'center' ? 'text-center' : ''}`}>
      {/* 區塊序號 + 英文標籤 */}
      {(sectionNumber || englishLabel) && (
        <div
          className={`flex items-center gap-3 mb-4 ${
            align === 'center' ? 'justify-center' : ''
          } ${isDark ? 'text-background-300/[0.42]' : 'text-foreground-400/[0.42]'}`}
        >
          {sectionNumber && (
            <span className="font-mono text-[11px] tracking-[0.3em]">{sectionNumber}</span>
          )}
          {(sectionNumber && englishLabel) && (
            <span className={`w-6 h-px ${isDark ? 'bg-background-300/[0.20]' : 'bg-foreground-300/[0.20]'}`}></span>
          )}
          {englishLabel && (
            <span className="font-mono text-[11px] tracking-[0.2em] uppercase">{englishLabel}</span>
          )}
        </div>
      )}

      {/* 編輯式佈局：左側數字 + 中間標題 */}
      {isEditorial ? (
        <div className="flex items-start gap-5 md:gap-8">
          {sectionNumber && (
            <span className="flex-shrink-0 font-heading text-5xl md:text-6xl font-bold text-foreground-100 leading-none">
              {sectionNumber.replace(/^0/, '')}
            </span>
          )}
          <div>
            <h2 className={`font-heading text-2xl md:text-3xl font-bold ${
              isDark ? 'text-background-50' : 'text-foreground-900'
            }`}>
              {title}
            </h2>
            {subtitle && (
              <p className={`mt-3 text-sm md:text-base max-w-2xl leading-relaxed ${
                isDark ? 'text-background-300' : 'text-foreground-600'
              }`}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
      ) : (
        <>
          <h2 className={`font-heading text-2xl md:text-3xl font-bold ${
            isDark ? 'text-background-50' : 'text-foreground-900'
          }`}>
            {title}
          </h2>
          {subtitle && (
            <p className={`mt-3 text-sm md:text-base max-w-2xl leading-relaxed ${
              align === 'center' ? 'mx-auto' : ''
            } ${isDark ? 'text-background-300' : 'text-foreground-600'}`}>
              {subtitle}
            </p>
          )}
        </>
      )}
    </div>
  );
}